// extracted by mini-css-extract-plugin
export var SearchPopover = "SearchPopover-module--SearchPopover--c6870";
export var back = "SearchPopover-module--back--09124";